<template>
  <navBar>
    <div slot="left">
      <a class="nav-link">
        <router-link class="" to="/">
          <div class="boomy-logo-container">
            <img
              class="logo mr-3"
              src="../../public/img/boomy/dark-logo.svg"
              alt="logo"
            />
            &nbsp;boomy
          </div>
        </router-link>
      </a>
    </div>
    <div slot="right">
      <div v-if="isLoggedIn">
        <a class="nav-link">
          <router-link to="/account">
            <Avatar :size="32" :customPhoto="user.imageUrl"></Avatar>
            <div class="user-name hide-small-screen">{{ user.username }}</div>
          </router-link>
        </a>
      </div>
      <div v-else>
        <router-link
          class="mr-2 sign-in-button"
          :to="ROUTES.signIn.path"
          id="sign_in_desktop"
        >
          <Button variant="outline">Sign In</Button>
        </router-link>
        <router-link
          :to="ROUTES.signUp.path"
          id="sign_up_desktop"
          class="sign-up-button"
        >
          <Button variant="primary">Sign Up</Button>
        </router-link>
      </div>
    </div>
  </navBar>
</template>

<script>
import NavBar from "./NavBar";
import Button from "./Button";
import Avatar from "./Avatar";
import { ROUTES } from "@/router/routes";

export default {
  name: "topBar",
  props: {
    user: {
      type: Object,
      default: () => ({
        username: ""
      }),
      description: "Object containing users profile info"
    }
  },
  components: {
    navBar: NavBar,
    Button: Button,
    Avatar: Avatar
  },
  computed: {
    isLoggedIn() {
      return this.user.email !== "";
    }
  },
  created() {
    this.ROUTES = ROUTES;
  }
};
</script>

<style scoped>
.boomy-logo-container {
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #f81a55;
}
.logo {
  height: 32px;
  width: 32px;
}

.nav-link {
  padding-left: 0;
  padding-right: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #d5cff5;
  margin-left: 12px;
}

.hide-small-screen {
  display: none !important;
}
.show-small-screen {
  display: block !important;
}

@media (min-width: 768px) {
  .hide-small-screen {
    display: block !important;
  }
  .show-small-screen {
    display: show !important;
  }
}
@media (max-width: 340px) {
  .sign-up-button {
    display: none !important;
  }
  .sign-in-button {
    margin-right: 0 !important;
  }
}
</style>
